module.exports = __webpack_public_path__ + "static/media/white-logo.d5b60562.png";